import { ChakraProvider } from '@chakra-ui/react';
import { Box } from '@joinrepublic/dls-ui-kit';
import { observer } from 'mobx-react-lite';
import { GetServerSideProps } from 'next';
import Head from 'next/head';

import {
  BLOG_CATEGORIES,
  BLOG_CATEGORIES_KEYS,
  BlogCollection,
  BlogHeader,
  getCategoryBySlug,
} from '@r-client/republic/feature/blog';
import { ErrorBoundary } from '@r-client/republic/feature/errors';
import { MainLayout } from '@r-client/republic/feature/main-layout';
import { republicLegacy } from '@r-client/republic/ui/theme';

interface IBlogCategoryPageProps {
  currentCategory: (typeof BLOG_CATEGORIES_KEYS)[number];
}

export const getServerSideProps: GetServerSideProps<
  IBlogCategoryPageProps
> = async ({ params }) => {
  const categorySlug =
    typeof params?.category === 'string' ? params.category : undefined;
  const currentCategory = getCategoryBySlug(categorySlug);

  if (!currentCategory) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      currentCategory,
    },
  };
};

const BlogCategoryPage = observer(function BlogCategoryPage({
  currentCategory,
}: IBlogCategoryPageProps) {
  const categoryData = BLOG_CATEGORIES[currentCategory];

  return (
    <ChakraProvider theme={republicLegacy}>
      <MainLayout>
        <Head>
          <title>{categoryData.label} &mdash; Republic</title>
          <link
            rel="alternate"
            type="application/atom+xml"
            title="ATOM"
            href={`/insights/${categoryData.slug}.atom`}
          />
        </Head>
        <ErrorBoundary>
          <Box mt={{ base: '18', sm: '24' }} mb="24">
            <BlogHeader
              title={categoryData.label}
              currentCategory={currentCategory}
            />
            <BlogCollection category={currentCategory} />
          </Box>
        </ErrorBoundary>
      </MainLayout>
    </ChakraProvider>
  );
});

export default BlogCategoryPage;
